if (typeof debounce === "undefined") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get("theme-header")) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector(".header-section");
      this.menus = Array.from(this.querySelectorAll(".mobile-menu-drawer"));
      this.toggle = this.querySelector(".mobile-toggle-wrapper");
      this.scrollTicking = false;
      this.stickyOffset = 0;
      this.onScroll = this.onScroll.bind(this);

      document.addEventListener("keyup", (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === "ESCAPE") {
            this.toggle.removeAttribute("open");
            this.toggle.classList.remove("active");
          }
        }
      });
      if (this.classList.contains("header-sticky--active")) {
        document.body.classList.add("header-sticky--active");
      }
      this.toggle
        .querySelector(".mobile-toggle")
        .addEventListener("click", (e) => {
          if (this.toggle.classList.contains("active")) {
            e.preventDefault();
            document.body.classList.remove("overflow-hidden");
            this.toggle.classList.remove("active");
            this.closeAnimation(this.toggle);
          } else {
            document.body.classList.add("overflow-hidden");
            setTimeout(() => {
              this.toggle.classList.add("active");
            });
          }
        });

      window.addEventListener("scroll", this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => {
        this.updateMeasurements();
        this.updateStickyState();
      });
      this.resizeObserver.observe(this);
      const announcementBar = document.querySelector(".announcement-bar-section");
      if (announcementBar) this.resizeObserver.observe(announcementBar);

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector(".header-mobile-navigation");

        if (this.mobile_nav && this.classList.contains("transparent--true")) {
          this.mobile_nav.classList.add("is-fixed");
        }
      }, 100);
      // Buttons: Attach listeners to all mobile-menu-drawer elements
      this.menus.forEach((menu) => {
        menu
          .querySelectorAll("summary")
          .forEach((summary) =>
            summary.addEventListener("click", this.onSummaryClick.bind(this)),
          );
        menu
          .querySelectorAll(".parent-link-back--button")
          .forEach((button) =>
            button.addEventListener(
              "click",
              this.onCloseButtonClick.bind(this),
            ),
          );
      });
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this.onScroll);
      this.resizeObserver?.disconnect();
    }
    updateMeasurements() {
      const a_bar = document.querySelector(".announcement-bar-section");
      const announcementHeight = a_bar ? a_bar.clientHeight : 0;
      const headerHeight = this.clientHeight;
      const headerOffset = this.header_section
        ? this.header_section.getBoundingClientRect().top
        : 0;
      this.stickyOffset = headerOffset + window.scrollY;
      const rootStyle = document.documentElement.style;
      const measurements = {
        "--announcement-height": `${announcementHeight}px`,
        "--header-height": `${headerHeight}px`,
        "--header-offset": `${headerOffset}px`,
      };
      Object.entries(measurements).forEach(([property, value]) => {
        if (rootStyle.getPropertyValue(property) !== value) {
          rootStyle.setProperty(property, value);
        }
      });
    }
    updateStickyState() {
      if (!this.classList.contains("header-sticky--active")) return;
      const scrollY = window.scrollY;
      this.classList.toggle(
        "is-sticky",
        scrollY >= this.stickyOffset && scrollY > 0,
      );
    }
    onScroll() {
      if (this.scrollTicking) return;
      this.scrollTicking = true;
      window.requestAnimationFrame(() => {
        this.updateStickyState();
        this.scrollTicking = false;
      });
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest(".link-container");
      const menuDrawer = summaryElement.closest(".mobile-menu-drawer");
      if (menuDrawer && menuDrawer.querySelector(".parent-link-back--button")) {
        menuDrawer.scrollTop = 0;
      }
      window.requestAnimationFrame(() => {
        if (detailsElement.open) {
          detailsElement.classList.add("menu-opening");
          parentMenuElement && parentMenuElement.classList.add("submenu-open");
        }
      });
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove("menu-opening");
      detailsElement.classList.remove("submenu-open");
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute("open");
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define("theme-header", ThemeHeader);
}

if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
      this.submenus = this.querySelectorAll(
        ".thb-full-menu > .menu-item-has-children:not(.menu-item-has-megamenu) > .sub-menu",
      );
    }

    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;

      // Resize on initial load
      document.fonts.ready.then(() => {
        window.addEventListener(
          "resize",
          debounce(() => {
            _this.resizeSubMenus();
          }, 100),
        );
      });
    }

    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        const subSubmenus = submenu.querySelectorAll(
          ":scope > .menu-item-has-children > .sub-menu",
        );

        subSubmenus.forEach((subSubmenu) => {
          const submenuRect = subSubmenu.getBoundingClientRect();
          const submenuRightEdge = submenuRect.left + submenuRect.width;
          const submenuIsOverflowing = submenuRightEdge > window.innerWidth;

          if (submenuIsOverflowing) {
            subSubmenu.parentElement.classList.add("left-submenu");
          } else {
            subSubmenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }

  customElements.define("full-menu", FullMenu);
}
